import { Box, Typography, Avatar, Paper } from "@mui/material";

const FormSection = ({ title, icon: Icon, children }) => (
    <Paper sx={{
        p: { xs: 2, md: 3 }, mb: 3, borderRadius: 4, border: '1px solid #f1f5f9',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.02), 0 1px 2px -1px rgba(0, 0, 0, 0.02)',
        '&:hover': { boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.04)' },
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
            <Avatar sx={{ bgcolor: (theme) => `${theme.palette.primary.main}33`, color: 'primary.main', mr: 2, width: 44, height: 44 }}>
                <Icon sx={{ fontSize: 24 }} />
            </Avatar>
            <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', letterSpacing: '-0.01em' }}>
                {title}
            </Typography>
        </Box>
        <Box sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
            gap: 2.5,
            '& > *': { minWidth: 0 }
        }}>
            {children}
        </Box>
    </Paper>
);

export default FormSection;
